<template>
  <div class="ima-slogan-modal">


        <b-field label="Text*">
          <b-input type="textarea" v-model="text" :required="true" ref="autofocus"></b-input>
        </b-field>

        <b-field label="Beschreibung">
          <b-input type="textarea" v-model="description" :required="true"></b-input>
        </b-field>


    <div :style="{'text-align': 'right'}">
      <button type="button" class="button is-success" :disabled="!isValidForm || slogans.isSaving" @click="onConfirm">OK</button>
      <button type="button" class="button is-danger" :disabled="slogans.isSaving" @click="onCancel">Abbrechen</button>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { saveSlogan, unselectSlogan } from '@/store/modules/slogans'
import { closeModals } from '@/store/modules/modals'
import modals from '@/mixins/modals'

export default {
  name: 'ima-slogan-modal',
  data () {
    return {
      id: null,
      text: null,
      description: null
    }
  },
  computed: {
    ...mapState(['slogans']),
    isValidForm () {
      return this.text && this.text.length
    }
  },
  mixins: [modals],
  methods: {
    ...mapActions([saveSlogan]),
    ...mapMutations([closeModals, unselectSlogan]),
    onCancel () {
      this.unselectSlogan()
      this.closeModals()
    },
    onConfirm () {
      const { id, text, description } = this
      const slogan = {
        id,
        text,
        description
      }
      this.saveSlogan(slogan).then(slogan => {
        if (slogan) {
          this.closeModals()
          this.unselectSlogan()
        }
      })
    }
  },
  created () {
    if (this.slogans.selectedSlogan) {
      const { id, text, description } = this.slogans.selectedSlogan
      this.id = id
      this.text = text
      this.description = description
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/SloganModal.vue